//
// Copyright 2023 DXOS.org
//
/**
 * Version for the schema of the stored data as defined in dxos.echo.metadata.EchoMetadata.
 * update when making breaking changes to the protocols or other stored data.
 */
export const STORAGE_VERSION = 2;
//# sourceMappingURL=storage.js.map